var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoglixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.127,
    height: 20,
    viewBox: "0 0 58.127 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#d9232d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.127,
    height: 20,
    transform: "translate(-550.074 -166.991)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(550.074 166.991)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-550.074 -166.991)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.423)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-534.823-72.385h-2.659c.145-1.692.205-3.335.205-4.931a4.024,4.024,0,0,0-.459-2.344,1.826,1.826,0,0,0-1.474-.556,3.124,3.124,0,0,0-1.716.592q-.036,1.251-.036,2.248c0,1.112.024,2.779.06,4.991h-2.683c.145-1.837.218-3.613.218-5.341a3.65,3.65,0,0,0-.375-1.921,1.744,1.744,0,0,0-1.559-.568,2.423,2.423,0,0,0-1.813.737c.036,2.647.048,5.015.048,7.106h-2.695q.181-3.136.181-4.931a20.553,20.553,0,0,0-.5-4.52l2.562-.278.169,1.063h.157a4.277,4.277,0,0,1,2.937-1.184,3.279,3.279,0,0,1,2.876,1.184h.157a4.755,4.755,0,0,1,2.936-1.184,3.871,3.871,0,0,1,2.574.737,3.371,3.371,0,0,1,.87,2.671c0,.133-.012.375-.024.725s-.024.6-.024.725C-534.859-76.264-534.847-74.6-534.823-72.385Z",
    transform: "translate(550.074 82.222)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.843 4.29)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-236.33-79.778a5.1,5.1,0,0,1-1.559,3.952,5.232,5.232,0,0,1-3.662,1.426,4.979,4.979,0,0,1-3.444-1.293,4.707,4.707,0,0,1-1.438-3.662,5.135,5.135,0,0,1,1.559-3.976,5.272,5.272,0,0,1,3.674-1.438,4.875,4.875,0,0,1,3.42,1.305A4.685,4.685,0,0,1-236.33-79.778Zm-2.622.3a4.24,4.24,0,0,0-.677-2.441,2.074,2.074,0,0,0-1.776-.991,2.033,2.033,0,0,0-1.728.918,3.833,3.833,0,0,0-.665,2.308,4.24,4.24,0,0,0,.677,2.441,2.074,2.074,0,0,0,1.776.991,2.033,2.033,0,0,0,1.728-.918A3.833,3.833,0,0,0-238.953-79.476Z",
    transform: "translate(246.433 84.769)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.393 3.129)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-33.41-106.807l-.218,1.861c-1.039,0-1.692.145-1.958.447v.133a2.642,2.642,0,0,1,.592,1.68,3.259,3.259,0,0,1-1.063,2.453,4.379,4.379,0,0,1-3.154,1.015,7.2,7.2,0,0,1-1.68-.157c-.35.157-.532.375-.532.628a.88.88,0,0,0,.64.858,10.485,10.485,0,0,0,2.961.242c2.683,0,4.024.918,4.024,2.743a3.5,3.5,0,0,1-1.68,3.057,7.051,7.051,0,0,1-4.073,1.136q-4.695,0-4.689-2.949a2.356,2.356,0,0,1,.532-1.547,2.083,2.083,0,0,1,1.221-.773v-.145a1.794,1.794,0,0,1-.846-1.619,2.176,2.176,0,0,1,1.148-1.849v-.145a2.665,2.665,0,0,1-1.619-2.538,3.165,3.165,0,0,1,1.124-2.465,5.088,5.088,0,0,1,3.456-.991,4.964,4.964,0,0,1,2.586.6h.145c.193-1.269.846-1.9,1.946-1.9A2.613,2.613,0,0,1-33.41-106.807Zm-2.864,12.653a1.154,1.154,0,0,0-.568-1.076,4.168,4.168,0,0,0-1.946-.326c-.749,0-1.511-.036-2.272-.1a1.665,1.665,0,0,0-.882,1.547c0,1.281.858,1.921,2.562,1.921a4.13,4.13,0,0,0,2.272-.544A1.623,1.623,0,0,0-36.274-94.154Zm-1.184-8.254a1.671,1.671,0,0,0-.58-1.378,2.057,2.057,0,0,0-1.329-.471,2.033,2.033,0,0,0-1.317.459,1.591,1.591,0,0,0-.568,1.341,1.622,1.622,0,0,0,.58,1.353,2.132,2.132,0,0,0,1.353.459,2,2,0,0,0,1.293-.447A1.558,1.558,0,0,0-37.458-102.408Z",
    transform: "translate(44.237 107.026)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M191.675-152.731h-2.743c.1-2.3.145-4.773.145-7.456a60.489,60.489,0,0,0-.314-6.647l2.9-.157c-.1,1.9-.145,4.157-.145,6.816C191.53-157.492,191.578-155,191.675-152.731Z",
    transform: "translate(-188.762 166.991)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.239 0.205)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M281.515-149H278.82c.1-1.39.145-2.973.145-4.761a28.071,28.071,0,0,0-.338-4.677l2.888-.29c-.085,1.293-.133,2.949-.133,4.967C281.37-152.044,281.418-150.449,281.515-149Zm.459-12.556a1.7,1.7,0,0,1-.471,1.2,1.684,1.684,0,0,1-1.293.508,1.379,1.379,0,0,1-1.1-.447,1.53,1.53,0,0,1-.4-1.063,1.672,1.672,0,0,1,.471-1.184,1.693,1.693,0,0,1,1.305-.508,1.394,1.394,0,0,1,1.1.435A1.6,1.6,0,0,1,281.974-161.555Z",
    transform: "translate(-278.627 163.053)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.495 4.834)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.335)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M373.5-74.347h2.683a11.37,11.37,0,0,1-1.341,2.006,20.692,20.692,0,0,1-1.764,2.2v.157a33.338,33.338,0,0,1,2.006,2.719,18.9,18.9,0,0,1,1.486,2.4l-3.118.048a12.228,12.228,0,0,0-.858-1.813,22.892,22.892,0,0,0-1.2-2.042h-.133a16.82,16.82,0,0,0-1.088,2.006,8.431,8.431,0,0,0-.749,1.837h-2.792a12.152,12.152,0,0,1,1.462-2.344,22.772,22.772,0,0,1,2.018-2.683V-70a27.71,27.71,0,0,1-1.74-2.26,10.4,10.4,0,0,1-1.341-2.079h3.118a6.223,6.223,0,0,0,.677,1.547,15.331,15.331,0,0,0,1,1.728h.121a10.276,10.276,0,0,0,.931-1.7A6.383,6.383,0,0,0,373.5-74.347Z",
    transform: "translate(-366.639 74.347)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.063 10.598)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M480.313,129.44a2.219,2.219,0,0,1,.677,1.619,2.311,2.311,0,0,1-2.284,2.284,2.218,2.218,0,0,1-1.619-.677,2.18,2.18,0,0,1-.665-1.607,2.27,2.27,0,0,1,2.284-2.284A2.181,2.181,0,0,1,480.313,129.44Z",
    transform: "translate(-476.422 -128.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M480.313,129.44a2.219,2.219,0,0,1,.677,1.619,2.311,2.311,0,0,1-2.284,2.284,2.218,2.218,0,0,1-1.619-.677,2.18,2.18,0,0,1-.665-1.607,2.27,2.27,0,0,1,2.284-2.284A2.181,2.181,0,0,1,480.313,129.44Z",
    transform: "translate(-476.422 -128.775)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.84 10.598)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M361.034,129.44a2.219,2.219,0,0,1,.677,1.619,2.311,2.311,0,0,1-2.284,2.284,2.219,2.219,0,0,1-1.619-.677,2.18,2.18,0,0,1-.665-1.607,2.269,2.269,0,0,1,2.284-2.284A2.18,2.18,0,0,1,361.034,129.44Z",
    transform: "translate(-357.143 -128.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M361.034,129.44a2.219,2.219,0,0,1,.677,1.619,2.311,2.311,0,0,1-2.284,2.284,2.219,2.219,0,0,1-1.619-.677,2.18,2.18,0,0,1-.665-1.607,2.269,2.269,0,0,1,2.284-2.284A2.18,2.18,0,0,1,361.034,129.44Z",
    transform: "translate(-357.143 -128.775)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.556 11.915)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M236.705,154.673c1.414-.254,1.414-.459,0-.628l.121-.024h3.746l.1.012a.694.694,0,0,1,0,.653h-3.843A.2.2,0,0,1,236.705,154.673Z",
    transform: "translate(-236.705 -154.021)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M226.112,185.137h-.06q2.048-.344,0-.544h5.68a.236.236,0,0,1,.1.012.454.454,0,0,1,0,.52.235.235,0,0,1-.1.012Z",
    transform: "translate(-226.051 -184.593)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoglixLogo);
export default __webpack_public_path__ + "static/media/moglix-logo.494f13fd289bb6bebd16cd0512a17731.svg";
export { ForwardRef as ReactComponent };